module.exports = __webpack_public_path__ + "static/media/om_eyeshape_upturned_lightbrown.8ff818ba.png";